import { motion, AnimatePresence } from "framer-motion";
import ChatBot from "./ChatBot";
// import { chatModesMap } from "../config/chatModesMap";

const ChatBotContainer = ({
  initialMode,
  chatModesMap,
  companyCode,
  regionCode,
  userCode,
}) => {
  return (
    <div className="h-full flex flex-col bg-white dark:bg-gray-800 transition-colors">
      <div className="flex items-center px-4 py-3 border border-gray-300 dark:border-gray-600 transition-colors">
        <div className="flex items-center gap-2">
          <span className="h-2 w-2 bg-green-500 dark:bg-green-400 rounded-full transition-colors"></span>

          <span className="flex items-center justify-center h-5 w-5">
            {chatModesMap[initialMode]?.icon || null}
          </span>
          
          <span className="text-sm font-medium text-gray-700 dark:text-gray-300">
            {chatModesMap[initialMode]?.label || 'Chat Mode'}
          </span>
        </div>
      </div>

      <div className="flex-1 bg-gray-50 dark:bg-gray-900 overflow-hidden transition-colors">
        <AnimatePresence mode="wait">
          <motion.div
            key={initialMode}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
            className="h-full"
          >
            <ChatBot
              chatMode={initialMode}
              chatModesMap={chatModesMap}
              companyCode={companyCode}
              regionCode={regionCode}
              userCode={userCode}
            />
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default ChatBotContainer;
